export const PICTURE_LAZY_CLASS = "picture-lazy";
export const PICTURE_LAZY_ATTRIBUTE = "data-source";
